import { createAuth0 } from "@auth0/auth0-vue";
import { frontendConfig } from "./frontend_config";

export const auth0 = createAuth0({
    domain: frontendConfig.AUTH0_DOMAIN,
    clientId: frontendConfig.AUTH0_CLIENT_ID,
    authorizationParams: {
        redirect_uri: window.location.origin,
    },
})
